module.exports = __webpack_public_path__ + "img/hugg.ccf2d178.png";